import classNames from 'classnames';
import React, { useCallback, useMemo } from 'react';
import { Checkbox as TPACheckbox } from 'wix-ui-tpa/cssVars';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import { FIELD_ERROR_CLASS, useError } from '../../field-error';
import styles from './checkbox-field-wut.scss';
import { classes } from './checkbox-field-wut.st.css';
import RicosViewer from '../ricos-viewer/ricos-viewer';
import { useRicosTheme } from '../ricos-viewer/theme-utils';
const RICOS_THEME = {
  customStyles: {
    p: {
      fontSize: 'var(--wix-forms-formInputValueFont-size)',
      fontFamily: 'var(--wix-forms-formInputValueFont-family)',
      color: 'rgb(var(--wix-forms-formInputValueColor))'
    }
  }
};
export const CheckboxFieldWUT = _ref => {
  let {
    id,
    label,
    disabled = false,
    value = false,
    onChange,
    onFocus,
    onBlur,
    error,
    customErrors,
    fieldType,
    required,
    FieldLayout
  } = _ref;
  const {
    hasError,
    errorMessage
  } = useError(error, customErrors, fieldType);
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const customTheme = useRicosTheme(RICOS_THEME);
  const _label = useMemo(() => /*#__PURE__*/React.createElement(RicosViewer, {
    content: label,
    className: classNames({
      [styles.ricosDisabled]: disabled
    }),
    customTheme: customTheme
  }), [disabled, label, customTheme]);
  const handleChange = useCallback(event => {
    onChange == null || onChange(event.checked);
  }, [onChange]);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => null,
    renderInput: () => /*#__PURE__*/React.createElement("div", {
      onBlur: onBlur,
      onFocus: onFocus
    }, /*#__PURE__*/React.createElement(TPACheckbox, {
      newErrorMessage: true,
      className: classNames(styles.checkbox, classes.root, classes.checkbox, {
        [FIELD_ERROR_CLASS]: hasError,
        [classes.hover]: forcedHover
      }),
      label: _label,
      checked: Boolean(value),
      onChange: handleChange,
      disabled: disabled,
      error: hasError,
      errorMessage: errorMessage,
      required: required,
      showAsterisk: false
    })),
    renderDescription: () => null
  });
};
//# sourceMappingURL=checkbox-field-wut.js.map